export default __webpack_public_path__ + "static/derryl-74e3626813d51de14a6c21cf19a71c50.jpg";